/**
 * Created by Administrador on 20/07/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('embarkation', {
                parent: 'app',
                url: '/embarkation',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargo/embarkation/embarkation.html',
                        controller: 'embarkationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoOperationReport('embarkation')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReport']);
                            }],
                            'branchOffices': ['branchOfficeService', function(branchOfficeService){
                                return branchOfficeService.getBranchOfficesAssociatedAirport(true)
                            }]
                        }
                    }
                }
            });
    }
})();
